import styles from './PageNavigation.module.scss';
import { IconButton, Icon } from '@eventbrite/marmalade';
import { ArrowLeftIcon, ArrowRightIcon } from '@/components/_shared/Icons';

export const PageNavigation = ({
  canScrollPrev,
  canScrollNext,
  onScrollPrev,
  onScrollNext,
}: {
  canScrollPrev: boolean;
  canScrollNext: boolean;
  onScrollPrev: () => void;
  onScrollNext: () => void;
}) => {
  if (!canScrollPrev && !canScrollNext) {
    return null;
  }

  return (
    <div className={styles.pagers}>
      <IconButton
        className={canScrollPrev ? '' : styles.notClickable}
        variant="onLightBackground"
        icon={
          <Icon size="xsmall">
            <ArrowLeftIcon className={canScrollPrev ? styles.clickableIcon : styles.notClickableIcon} />
          </Icon>
        }
        aria-label="Previous agenda tab"
        disabled={!canScrollPrev}
        onClick={() => onScrollPrev()}
      />
      <IconButton
        className={canScrollNext ? styles.clickable : styles.notClickable}
        variant="onLightBackground"
        icon={
          <Icon size="xsmall">
            <ArrowRightIcon className={canScrollNext ? styles.clickableIcon : styles.notClickableIcon} />
          </Icon>
        }
        aria-label="Next agenda tab"
        disabled={!canScrollNext}
        onClick={() => onScrollNext()}
      />
    </div>
  );
};
